import { render, staticRenderFns } from "./Multilanguage.vue?vue&type=template&id=bab335da&scoped=true&"
import script from "./Multilanguage.vue?vue&type=script&lang=js&"
export * from "./Multilanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab335da",
  null
  
)

export default component.exports